<template>
<div class="login-dialog-wrap" v-show="show">
    <div class="dialog-content-wrap">
        <div class="title">温馨提示</div>
        <div class="login-ciontent">
            <h1>您尚未登录</h1>
            <p>请先登录在进行操作</p>
        </div>
        <div class="btn-wrap">
            <a class="btn-item cancel-btn-item" @click="_onCancel">取消登录</a>
            <a class="btn-item submit-btn-item" @click="_onConfirm">立即登录</a>
        </div>
    </div>
    <div class="dialog-bg-wrap" @click="_onCancel"></div>
</div>
</template>

<script>
export default {
    name: 'LoginDialog',
    data() {
        return {
            show: false,
            value: false,
            SCOPE: 'snsapi_userinfo',
            STATE: 'userinfo',
        };
    },
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        _show(value) {
            this.value = value;
            // this.show = true;

            let params = {
                title: '温馨提示',
                message: '您尚未登录，要现在登录吗？',
            };
            this.AlertManager.confirm(params).then(() => {
                this._onConfirm();
            }).catch((error) => {
                console.log('error---->', error);
            });
        },

        _onConfirm() {
            if (this.$isWeiXin()) {
                let APPID = this.Constants.WECHAT_APPID;
                let REDIRECT_URI = encodeURIComponent(this.API.HOST_H5);
                let SCOPE = this.SCOPE
                let STATE = this.STATE
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=${SCOPE}&state=${STATE}#wechat_redirect`
            } else {
                this.show = false;
                this._onPressToNavigate('', 'login');
            }
        },

        _onCancel() {
            this.show = false;
        },
    }
};
</script>

<style lang="less">
.login-dialog-wrap {
    .dialog-bg-wrap {
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 1000;
        position: fixed;
        background-color: rgba(0, 0, 0, 0.4);
    }

    .dialog-content-wrap {
        top: 50%;
        left: 50%;
        width: 70%;
        z-index: 1001;
        position: fixed;
        overflow: hidden;
        border-radius: 1rem;
        background-color: #fff;
        transform: translate(-50%, -50%);

        .title {
            color: #fff;
            display: flex;
            font-size: 1.8rem;
            align-items: center;
            padding: 1.5rem 1rem;
            justify-content: center;
            background-color: #7282eb;
        }

        .login-ciontent {
            color: #666;
            font-size: 1.5rem;
            padding: 4rem 2rem;
            text-align: center;

            h1 {
                color: #444;
                line-height: 2;
                font-size: 1.8rem;
            }

            p {
                color: #888;
                line-height: 1.8;
                font-size: 1.4rem;
            }
        }

        .btn-wrap {
            display: flex;
            margin-bottom: 2rem;
            justify-content: space-around;

            .btn-item {
                color: #fff;
                display: flex;
                margin: 0 1rem;
                align-items: center;
                border-radius: 1rem;
                padding: 1rem 2.5rem;
                justify-content: center;
                background-color: #7282eb;
            }

            .cancel-btn-item {
                color: #666;
                background-color: #dbdbdb;
            }
        }
    }
}
</style>
